import script from "./DiagnosticSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiagnosticSection.vue?vue&type=script&setup=true&lang=ts"

import "./DiagnosticSection.vue?vue&type=style&index=0&id=ad49a598&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad49a598"]])

export default __exports__